import CURRENCIES from 'resources/currencies';
/**
 * Prepares backend-annotated propensities for the tile.
 *
 * The nxt_tile lambda (react_app PR #2258, MPI-611) returns each propensity with
 * `name`, `action` and `publish_scores` already attached and a literal "$" in the
 * labels. This substitutes the client's currency symbol and drops any propensity
 * the backend could not label, which is its fallback when the y_var config fails
 * to load.
 */
export default function annotatePropensities(propensities, currency) {
    const currencySymbol = CURRENCIES[currency]?.symbol ?? '$';
    return (propensities || [])
        .filter((propensity) => typeof propensity.name === 'string' && propensity.name !== '')
        .map((propensity) => ({
            ...propensity,
            currencySymbol,
            name: propensity.name.replace('$', currencySymbol),
            action: (propensity.action || '').replace('$', currencySymbol)
        }));
}
